<template>
  <div id="footer" class="acea-row row-middle">
    <!-- <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <div
        class="iconfont"
        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
      ></div>
      <div>{{ item.name }}</div>
    </router-link>-->
    <van-tabbar route>
      <!-- <van-tabbar-item replace to="/home" icon="home-o">标签</van-tabbar-item> -->
      <van-tabbar-item
        replace
        v-for="(item, index) in footerList"
        :key="index"
        :to="item.url"
        class="item"
        :class="{ on: item.url === $route.path }"
        :badge="item.name === '购物车' && carnum"
      >
        <template #icon>
          <div
            class="iconfont"
            :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
          ></div>
        </template>
        {{ item.name }}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getCartCount } from "@api/store";
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: "icon-shouye-xianxing",
          icon2: "icon-shouye",
          url: "/"
        },
        {
          name: "分类",
          icon1: "icon-yingyongchengxu-xianxing",
          icon2: "icon-yingyongchengxu",
          url: "/category",
          num: ""
        },
        {
          name: "购物车",
          icon1: "icon-caigou-xianxing",
          icon2: "icon-caigou",
          url: "/cart"
        },
        {
          name: "我的",
          icon1: "icon-yonghu-xianxing",
          icon2: "icon-yonghu",
          url: "/user"
        },
        {
          name: "卡券",
          icon1: "icon-yingyongchengxu-xianxing",
          icon2: "icon-yingyongchengxu",
          url: "/card"
        }
      ],
      CartCount: ""
    };
  },
  methods: {
    //获取购物车数量
    getCartCount: function(isAnima) {
      let that = this;
      const isLogin = that.isLogin;
      if (isLogin) {
        getCartCount({ numType: 0 }).then(res => {
          that.CartCount = res.data.count;
        });
      }
    }
  },
  computed: {
    ...mapGetters(["isLogin"]),
    carnum() {
      this.getCartCount();
      // 先获取当前store数量 0/''可能是初始 请求后台获取购物车数量
      return this.$store.state.app.carNum || this.CartCount;
    }
  }
};
</script>
<style>
 
  #footer .van-tabbar-item .van-info{
    margin-top:8px !important;
  }
</style>